import { truncate } from 'lodash';
import { IsBoolean, IsEmail, IsInt, IsOptional, IsString, MaxLength, ValidateIf, Max, ValidateNested } from 'class-validator';

import { Address } from '../geo';

export class ContragentUpdateRequest {
    @IsOptional()
    @IsInt()
    public readonly id?: number;

    @IsOptional()
    @IsString()
    public readonly priceTypeUuid?: string;

    @IsString()
    @MaxLength(255)
    public readonly name?: string;

    @IsString()
    @MaxLength(25)
    public readonly shortName?: string;

    @IsOptional()
    @IsString()
    @MaxLength(255)
    public readonly id1C?: string;

    @IsOptional()
    @IsString()
    public readonly phone?: string;

    @ValidateIf((o: ContragentUpdateRequest) => !!o.email) // allow empty string
    @IsString()
    @IsEmail()
    public readonly email?: string;

    @IsOptional()
    @IsInt()
    public readonly dealerId?: number;

    @IsOptional()
    @IsBoolean()
    public readonly isForGauger?: boolean;

    @IsOptional()
    @IsInt()
    @Max(1000000000)
    public readonly ordersLimit?: number;

    @IsOptional()
    @IsBoolean()
    public readonly shippingIncluded?: boolean;

    @IsOptional()
    @IsBoolean()
    public readonly sendSmsNotification?: boolean;

    @IsOptional()
    @IsBoolean()
    public readonly showPublicOrderHistory?: boolean;

    @IsOptional()
    @IsString()
    public readonly contactPhone?: string;

    @IsOptional()
    @IsString()
    public readonly contactPerson?: string;

    @IsOptional()
    @ValidateNested()
    public readonly deliveryAddress: Address;

    @IsOptional()
    @IsInt()
    public readonly salesRepresentativeId?: number;

    constructor(data?: Partial<ContragentUpdateRequest>) {
        this.id = data?.id;
        this.priceTypeUuid = data?.priceTypeUuid;
        this.name = data?.name;
        this.shortName = data?.shortName || truncate(this.name, { length: 25 });
        this.id1C = data?.id1C;
        this.phone = data?.phone;
        this.email = data?.email;
        this.dealerId = data?.dealerId;
        this.isForGauger = data?.isForGauger;
        this.ordersLimit = data?.ordersLimit || 0;
        this.shippingIncluded = data?.shippingIncluded || false;
        this.sendSmsNotification = data?.sendSmsNotification ?? true;
        this.showPublicOrderHistory = data?.showPublicOrderHistory ?? true;
        this.contactPhone = data?.contactPhone;
        this.contactPerson = data?.contactPerson;
        this.deliveryAddress = data?.deliveryAddress && typeof data.deliveryAddress === 'object' ? new Address(data.deliveryAddress) : data?.deliveryAddress;
        this.salesRepresentativeId = data?.salesRepresentativeId;
    }
}
